const initiateFormDialogs = () => {
  const dialogTriggers = document.querySelectorAll(".dialog-trigger");
  const openOnLoad = document.querySelector(".dialog-open-on-load");
  const openOnLoadTarget = openOnLoad?.getAttribute("data-for");

  for (const dialogTrigger of dialogTriggers) {
    if (dialogTrigger.classList.contains("initialized")) {
      continue;
    }
    const dialogId = dialogTrigger.getAttribute("data-for");
    const dialog = document.getElementById(dialogId);
    const noClose = dialogTrigger.getAttribute("data-noclose") == "true";

    const keydownListener = function (e) {
      if (e.key === "Escape") {
        if (!noClose) {
          dialog.close();
          dialog.classList.add("hidden");
        }
        e.preventDefault();
      } else if (e.key === "Enter") {
        const submitButton = dialog.querySelector("button.close");
        if (submitButton) {
          submitButton.click();
        }
        e.preventDefault();
      }
    };

    // Add keydown listener if dialog should open on load
    if (openOnLoadTarget == dialogId) {
      document.addEventListener("keydown", keydownListener);
    }

    dialogTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      dialog.showModal();
      dialog.classList.remove("hidden");

      document.addEventListener("keydown", keydownListener);
    });
    const closebtns = dialog.querySelectorAll(".close");
    for (const closeBtn of closebtns) {
      closeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        dialog.close();
        dialog.classList.add("hidden");

        document.removeEventListener("keydown", keydownListener);
      });
    }
    dialogTrigger.classList.add("initialized");
  }

  // Open on load (ref. tenancydetailsedit.templ)
  if (openOnLoad) {
    const dialog = document.getElementById(openOnLoadTarget);
    if (dialog) {
      dialog.showModal();
      dialog.classList.remove("hidden");
    }
  }
};

window.addEventListener("DOMContentLoaded", initiateFormDialogs);
document.addEventListener("htmx:afterSwap", (evt) => {
  if (evt.detail.elt.getAttribute("hx-swap") !== "none") {
    initiateFormDialogs();
  }
});

// Used in ir_rooms to init new dialogs when creating rooms
document.addEventListener("alpine:init-dialogs", () => {
  // Need timeout to let dom elements to be created
  setTimeout(() => {
    initiateFormDialogs();
  }, 200);
});
